/**
 * assets/sos-fab.js
 * Gedrag van snippets/sos-fab.liquid
 *
 * Geknipt uit de inline <script> van dat bestand op 2026-08-15, 1:1.
 * Data komt uit dat bestand, gedrag staat hier. Zie ARCHITECTURE.md sectie 11.
 */

(() => {
  /* Scroll-to-top */
  const scrollBtn = document.getElementById('fab-scroll-top');
  if (scrollBtn) {
    let shown = false;
    window.addEventListener('scroll', () => {
      const show = window.scrollY > 600;
      if (show === shown) return;
      shown = show;
      scrollBtn.style.opacity = show ? '1' : '0';
      scrollBtn.style.pointerEvents = show ? 'auto' : 'none';
    }, { passive: true });
    scrollBtn.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  /* AI-chat: open Doofinder AI Assistant (officiële API). Fallback: Doofinder-zoek. */
  const aiBtn = document.getElementById('df-ai-chat-fab');
  if (aiBtn) {
    aiBtn.addEventListener('click', () => {
      try {
        if (window.Doofinder && Doofinder.AI && Doofinder.AI.Assistant && typeof Doofinder.AI.Assistant.open === 'function') {
          Doofinder.AI.Assistant.open();
          if (typeof gtag === 'function') gtag('event', 'ai_assistant_open', { event_category: 'Doofinder AI', event_label: 'fab' });
          return;
        }
      } catch (e) {}
      /* Fallback zolang de AI Assistant nog niet actief is: open de Doofinder-zoek */
      const inp = document.getElementById('df-mobile-search') || document.querySelector('input[name="q"]');
      if (inp) { inp.focus(); inp.click(); }
    });

    /* Subtiele puls bij eerste sessiebezoek om aandacht te trekken */
    if (!sessionStorage.getItem('ai-fab-pulsed')) {
      aiBtn.setAttribute('data-pulse', 'true');
      sessionStorage.setItem('ai-fab-pulsed', '1');
    }
  }
})();
